/** @jsx jsx */
import { jsx } from '@compiled/react';
import { Stack, xcss } from '@atlaskit/primitives';

import { CommentEdited } from '@atlaskit/comment';
import { useIntl } from '@atlassian/jira-intl';
import messages from '../messages.tsx';
import { useCommentContext } from './CommentContextProvider.tsx';

const CommentDeletedIndicator = () => {
	const { isDeleted } = useCommentContext();
	const intl = useIntl();

	if (!isDeleted) {
		return null;
	}

	return (
		<Stack xcss={commentDeletedStyles} alignBlock="center">
			<CommentEdited>{intl.formatMessage(messages.commentDeleted)}</CommentEdited>
		</Stack>
	);
};

const commentDeletedStyles = xcss({
	minHeight: '40px',
});

export default CommentDeletedIndicator;
